import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Text,
  Checkbox,
  Date,
  Email,
  File,
  Number,
  Select,
  Textarea,
  Amount,
  MobileNumber,
} from "../Components/fields/AllFields";
import FormHeader from "../Components/form/FormHeader";
import FormContext from "../context/FormContext";
import "./ViewForm.css";

const ViewForm = () => {
  const params = useParams();
  const { id } = params;

  const [error, seterror] = useState();
  const [FieldData, setFielddata] = useState([]);
  const [Info, setInfo] = useState([]);
  const [Loading, setLoading] = useState(false);

  const context = useContext(FormContext);
  const { formResponse, handleResponse, setResponse } = context;

  const components = {
    Text: Text,
    CheckBox: Checkbox,
    Date: Date,
    Email: Email,
    File: File,
    Number: Number,
    Select: Select,
    TextArea: Textarea,
    Amount: Amount,
    MobileNumber: MobileNumber,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formResponse);
    setLoading(true);
    await axios
      .post("https://erpapi.eshiksa.net/formBuilderResponseSave.php", {
        tag: "saveResponseBuilder",
        dbname: "erp_eshiksa",
        formUrlToken: id,
        ...formResponse,
        amount: Info.fixedAmount,
      })
      .then((res) => {
        setLoading(false);
        window.location.href = res.data.redirect_url;
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getData = async () => {
    setLoading(true);
    await axios
      .post("https://erpapi.eshiksa.net/formBuilderFieldData.php", {
        formUrlToken: id,
        dbname: "erp_eshiksa",
        tag: "fieldDataBuilder",
      })
      .then((res) => {
        setLoading(false);

        if (
          res.data.error !== 1 &&
          (parseInt(res.data.active_count) < parseInt(res.data.count) ||
            parseInt(res.data.count) === 0)
        ) {
          setFielddata(res.data.data);
          document.title = res.data.formName;
          setInfo(res.data);
        } else {
          seterror("Form Is Disabled");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
    console.log(id);
  };

  const handleImage = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    formData.append("tag", "imageUploadTransaction");
    formData.append("dbname", "erp_eshiksa");
    formData.append("formUrlToken", id);

    try {
      const response = await fetch(
        "https://erpapi.eshiksa.net/imageUploadFormBuilder_v2.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      setResponse({ ...formResponse, [e.target.name]: data.file_name });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, []);

  return (
    <>
      {Loading ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="spinner-border"
            style={{ color: "#f9AC1B" }}
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",

            justifyContent: "center",
            minHeight: "100%",
          }}
          className="py-5 form-background"
        >
          {error ? (
            <h1 className="text-center my-2">{error}</h1>
          ) : (
            <div className="w-75 form-body   py-4">
              <FormHeader Info={Info} />
              <form className="form-floating" onSubmit={(e) => handleSubmit(e)}>
                {FieldData.map((Field, i) => {
                  const Component = components[Field.Component];
                  return (
                    <Component
                      handleResponse={handleResponse}
                      FormInfo={Info}
                      setInfo={setInfo}
                      handleImage={handleImage}
                      key={i}
                      Item={Field}
                    />
                  );
                })}
                <div className="form-group my-2">
                  <label htmlFor="#Payment_Mode">Payment Mode</label>
                  <select
                    name="pay_mode"
                    onChange={(e) => handleResponse(e)}
                    className="form-control form-control_1"
                    id="Payment_Mode"
                    required
                  >
                    <option selected disabled value="">
                      select
                    </option>
                    <option value="CC">Credit Card</option>
                    <option value="DC">Debit Card</option>
                    <option value="NB">Net Banking</option>
                    <option value="UP">UPI</option>
                    <option value="DYNAMICQR">UPI QR</option>
                  </select>
                </div>
                <div className="d-flex justify-content-between mt-5 ">
                  <button className=" Reset-button ">Reset</button>
                  <button type="submit" className="submit-button ">
                    Submit
                  </button>
                </div>
                <hr
                  style={{ background: "#F17146", padding: "1px", opacity: 1 }}
                ></hr>
                 <div className="row align-items-center">
      <div className="col-10">
        
      </div>
      <div className="col-2">
        {Info.bank_partner_logo && (
          <img
            className="form-logo"
            src={`https://erp.eshiksa.net/DirectFeesv3/assets/img/${Info.bank_partner_logo}`}
            alt="logo"
          />
        )}
      </div>
    </div>

                <div>
                  {Info.terms_condition && (
                    <>
                      <h6> Terms & Condition </h6>
                      {Info.terms_condition.includes("_line") ? (
                        <>
                          {Info.terms_condition
                            .split("_line")
                            .map((point, i) => {
                              return (
                                <React.Fragment key={i}>
                                  {point.includes("<") ? (
                                    <h6>{point.match(/<(.*?)>/)[1]}</h6>
                                  ) : (
                                    <p
                                      style={{ fontSize: 11, fontWeight: 600 }}
                                    >
                                      {point}
                                    </p>
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </>
                      ) : (
                        <>
                          {Info.terms_condition.includes("<") ? (
                            <h6>{Info.terms_condition.match(/<(.*?)>/)[1]}</h6>
                          ) : (
                            <p style={{ fontSize: 11, fontWeight: 600 }}>
                              {Info.terms_condition}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {Info.description && (
                    <>
                      {Info.description.includes("_line") ? (
                        <>
                          {Info.description.split("_line").map((point, i) => {
                            return (
                              <React.Fragment key={i}>
                                {point.includes("<") ? (
                                  <h6>{point.match(/<(.*?)>/)[1]}</h6>
                                ) : (
                                  <p style={{ fontSize: 11, fontWeight: 600 }}>
                                    {point}
                                  </p>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {Info.description.includes("<") ? (
                            <h6>{Info.description.match(/<(.*?)>/)[1]}</h6>
                          ) : (
                            <p style={{ fontSize: 11, fontWeight: 600 }}>
                              {Info.description}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ViewForm;
